<template lang="pug">
  v-simple-checkbox(
    v-if="isCheckbox"
    :checked="isChecked"
    :value="isChecked"
    disabled
  )
  div(
    v-else
    class="templates-field-value"
    :style="valueStyles"
  ) {{ preValue }}
</template>

<script>
import { TYPES } from '~/modules/templates/constants/fields'

export default {
  name: 'TemplatesFieldValue',
  props: {
    field: {
      type: Object,
      default: null
    }
  },
  computed: {
    fontSize() {
      return this._.get(this.field, 'textSize', 12)
    },
    valueStyles() {
      return {
        fontSize: this.fontSize + 'px'
      }
    },
    preValue() {
      return this._.get(this.field, 'documentFieldPreValue')
    },
    isCheckbox() {
      return this.field.type === TYPES.checkbox
    },
    isChecked() {
      return this.preValue === 'checked'
    }
  },
  created() {
    this.$store.commit('templatefields/SET_FILLED_FIELD', {
      id: this.field.documentFieldId,
      value: this.preValue
    })
  }
}
</script>

<style scoped lang="scss">
.templates-field-value {
  font-family: 'Times New Roman', sans-serif;
  white-space: pre-wrap;
  letter-spacing: 1px;
  color: #000000;
}
</style>
